import { IPayload } from 'models/Global'
import {
  IGetLocationVerificationEvidenceAWSParams,
  IGetLocationVerificationEvidenceParams,
  ILocationVerificationEvidence,
  ILocationVerificationEvidenceAWS,
} from 'models/LocationVerificationEvidence'
import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'

export class LocationVerificationEvidenceApi {
  constructor(private axios: AxiosService) {}

  getLocationVerificationEvidence = async (params?: IGetLocationVerificationEvidenceParams) => {
    const response = await this.axios.get<IPayload<ILocationVerificationEvidence[]>>(
      Endpoints.getLocationVerificationEvidence,
      params
    )
    return response
  }

  getLocationVerificationEvidenceAWS = async (
    params?: IGetLocationVerificationEvidenceAWSParams
  ) => {
    const response = await this.axios.get<IPayload<ILocationVerificationEvidenceAWS>>(
      Endpoints.getLocationVerificationEvidenceAWS,
      params
    )
    return response
  }
}
